import SettingsIconDark from '@Resources/assets/icons/dark/settings.svg';
import SettingsIconLight from '@Resources/assets/icons/light/settings.svg';
import { SvgIcon, Tooltip } from '@mui/material';
import React from 'react';
import { ISettingsProps } from '@Components/Header/Interfaces';
import IconButton from '@Components/IconButton/IconButton';
import Styles from '@Components/IconButton/IconButton.scss';
import { SettingsType } from '@Components/Settings/SettingsType';

const OrganizationSettings = (props: ISettingsProps) => {
    const { onSettingsBtnClick, isSubmitting, settingsType, id } = props;

    const isSelected = settingsType === SettingsType.ORGADMIN;

    return (
        <Tooltip title="Organization Admin Settings">
            <div className={Styles.iconButtonWrapper}>
                <IconButton
                    id={id}
                    onClick={() => onSettingsBtnClick(SettingsType.ORGADMIN)}
                    disabled={isSubmitting}
                    isSelected={isSelected}
                    icon={
                        <SvgIcon inheritViewBox>
                            {isSelected ? (
                                <SettingsIconLight />
                            ) : (
                                <SettingsIconDark />
                            )}
                        </SvgIcon>
                    }
                />
            </div>
        </Tooltip>
    );
};

export default OrganizationSettings;
